import { Component, Input } from '@angular/core';
import { Dictionary } from 'src/app/core/models/common/generic.type.model';

@Component({
  selector: 'app-pdf-report-generator',
  templateUrl: './pdf-report-generator.component.html',
  standalone: false,
})
export class PdfReportGeneratorComponent<T> {
  private static readonly TABLE_FONT_CLASSES: Record<string, string> = {
    '10px': 'table-font-10',
    '12px': 'table-font-12',
    '14px': 'table-font-14',
    '16px': 'table-font-16',
  };

  private static readonly DATA_CELL_FONT_CLASSES: Record<string, string> = {
    '10px': 'data-cell-font-10',
    '12px': 'data-cell-font-12',
    '14px': 'data-cell-font-14',
    '16px': 'data-cell-font-16',
  };

  @Input() columns!: string[];
  @Input() columnsData!: Dictionary<T>[];
  @Input() dataFields!: string[];
  @Input() hasSingleSubHeaderView = true;
  @Input() hasTotalRow = false;
  @Input() isNonTableView = false;
  @Input() dataRowHeight = 30;
  @Input() columnDataFontSize = '12px';
  @Input() tableFontSize = '12px';
  @Input() columnWidths: number[] | null = null;
  defaultWidths: number[] = [];

  get tableFontClass(): string {
    return (
      PdfReportGeneratorComponent.TABLE_FONT_CLASSES[this.tableFontSize] ??
      'table-font-12'
    );
  }

  get dataCellFontClass(): string {
    return (
      PdfReportGeneratorComponent.DATA_CELL_FONT_CLASSES[
        this.columnDataFontSize
      ] ?? 'data-cell-font-12'
    );
  }

  getColWidth(index: number): string | null {
    const w = this.columnWidths?.[index] ?? this.defaultWidths?.[index];
    return typeof w === 'number' ? `${w}px` : null;
  }
}
